import bscscan from '../../images/binance-logo.svg'
import twitter from '../../images/twitter.svg'
import telegram from '../../images/telegram.svg'

export default function SocialsLinks() {

    return (
        <div>
            <div className="ml-auto d-flex justify-content-between align-items-end mt-4 mx-5">
                <a href='https://bscscan.com/address/#' target={'_blank'} rel="noreferrer">
                    <img alt='social-icons' src={bscscan} style={{ width: '25px', marginLeft: '15px', cursor: 'pointer' }} />
                </a>
                <a href='https://twitter.com/dragontacoon' target={'_blank'} rel="noreferrer">
                    <img alt='social-icons' src={twitter} style={{ width: '35px', cursor: 'pointer' }} />
                </a>
                <a href='https://t.me/dragontacoon' target={'_blank'} rel="noreferrer">
                    <img alt='social-icons' src={telegram} style={{ width: '25px', cursor: 'pointer' }} />
                </a>
            </div>
        </div>
    )
}